var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{class:{
            'text-right': true,
            'text-decoration-line-through': _vm.item.schedule_status_ident === 'cancelled',
        }},[_vm._v(" "+_vm._s(_vm.item.start_date.isValid() ? _vm.item.start_date.formatIf('DD.MM.YYYY') : '')+" ")]),(_vm.item.end_date.isValid() && _vm.item.end_date.isSame(_vm.item.start_date) !== true)?_c('div',{class:{
            'text-right': true,
        }},[_vm._v(" - "),_c('span',{class:{
                'text-decoration-line-through': _vm.item.schedule_status_ident === 'cancelled',
            }},[_vm._v(" "+_vm._s(_vm.item.end_date.formatIf('DD.MM.YYYY')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }